import { useMemo } from 'react';

import { IdentityMultiContentLayoutBase } from './IdentityMultiContentLayoutBase';
import { IdentityMultiContentLayoutProps, LayoutVariantConfig } from './types';

export const MOBILE_CONFIG: LayoutVariantConfig = {
  contentGap: 3,
  footerGap: 2,
  stackedPaddingTop: 3,
  stackedWidth: '100%',
  bottomStackedGap: 1,
  centerContent: false,
  pushFooterToBottom: true,
};

export function IdentityMultiContentLayoutMobile(props: IdentityMultiContentLayoutProps) {
  const config = useMemo(() => {
    return {
      ...MOBILE_CONFIG,
      ...(props.config ?? {}),
    };
  }, [props.config]);

  return <IdentityMultiContentLayoutBase {...props} config={config} />;
}
